import { Route, Routes } from 'react-router-dom'
import { useCurrentUser } from '~/common'
import { AddAdminPage, AdminDetailsPage, AdminUsersPage } from '~/modules/adminusers/view'
import { AuthWrapped } from '~/modules/navigation/components'

export const PATH = {
  OVERVIEW: '/',
  DETAILS: 'details',
  ADD: 'add',
}

export const AdminUsersRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('ADMIN_USERS')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={AdminUsersPage} canAccess={canAccess} />} />
      <Route path={PATH.ADD} element={<AuthWrapped component={AddAdminPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.DETAILS}/:userId`}
        element={<AuthWrapped component={AdminDetailsPage} canAccess={canAccess} />}
      />
    </Routes>
  )
}

export const adminUsersLinks = {
  usersLink: () => PATH.OVERVIEW,
  addFormLink: () => `/${PATH.ADD}`,
  userOverviewDetailsLink: (userId: string) => `/${PATH.DETAILS}/${userId}`,
}
